<template lang="pug">
.sidebar(
    :class="{'sidebar-extract': sidebarExtracted}",
    ref="sidebarCon",
    :style="sidebarStyle",
    @mousewheel="onMousewheel($event)",
    @scroll.stop="onScroll()"
)
    .menu-expand(ref="expander", v-show="canExtract", :title="descTitle", :style="expanderStyle")
        span 收起左侧导航
        svg(viewBox="0 0 1024 1024", width="20", height="20", @click="toggleSidebar", :class="{'extracted': sidebarExtracted}")
            path(d="M112.8 356h510.4c24.8 0 44.8 21.6 44.8 48.001s-20 48-44.8 48.001h-510.4c-24.8 0-44.8-21.6-44.8-48.001s20-48 44.8-48.001zM112.8 580h510.4c24.8 0 44.8 21.6 44.8 48.001s-20 48-44.8 48.001h-510.4c-24.8 0-44.8-21.6-44.8-48.001s20-48 44.8-48.001zM116 796h781.6c26.401 0 49.6 20.001 50.4 46.4 0.8 27.2-20.8 49.6-48.001 49.6h-781.6c-26.401 0-49.6-20.001-50.4-46.4-0.8-27.2 20.8-49.6 48.001-49.6zM948.001 356.8v318.4c0 0 0 0 0 0l-223.2-159.2c0 0 0 0 0 0l223.2-159.2c0-0.8 0-0.8 0 0zM900 236h-781.6c-26.401 0-49.6-20.001-50.4-46.4-0.8-27.2 20.8-49.6 48.001-49.6h781.6c26.401 0 49.6 20.001 50.4 46.4 0.8 27.2-20.8 49.6-48.001 49.6z")
    section(
        v-for="item in sidebar",
        :key="item.title",
        @mouseenter="sidebarExtracted && (item.focused = true)",
        @mouseleave="sidebarExtracted && (item.focused = false)"
    )
        h2(@click="item.expanded = !item.expanded")
            span.menu-icon(v-if="item.iconName && item.iconColor", :style="{background: item.iconColor}")
                i.fa(:class="['fa-'+item.iconName]")
            span.menu-title {{item.title}}
            i.arrow-toggle.fa(:class="{'fa-angle-down': item.expanded, 'fa-angle-right': !item.expanded}")
        ul.submenu(v-show="sidebarExtracted ? item.focused : item.expanded")
            li.submenu-item(
                v-for="link in item.links",
                :key="link.name",
                @click="sidebarExtracted && (item.focused = false)"
            )
                router-link(:to="link.to", v-if="!link.disabled")
                  span {{link.name}}
                  i.new-func(v-if="link.isNew")
                a(v-if="link.disabled", :class="{'disabled': link.disabled}")
                  span {{link.name}}
                  i.new-func(v-if="link.isNew")
</template>

<script>
import Vue from 'vue';

export default {
    props: {
        sidebar: {
            type: Array
        }
    },
    data() {
        const canExtract = !/^\/setting\//.test(this.$route.path);
        return {
            canExtract,
            sidebarHeight: 0,
            sidebarStyle: {
                paddingTop: canExtract ? '35px' : '0'
            },
            expanderStyle: {},
            sidebarExtracted: false //this.$store.state.sidebarStatus
        };
    },
    computed: {
        descTitle() {
            return !this.sidebarExtracted ? '收起' : '展开'
        }
    },
    watch: {
        sidebarExtracted() {
            this.$nextTick(() => {
                this.onScroll();
            })
        }
    },
    methods: {
        toggleSidebar() {
            this.sidebarExtracted = !this.sidebarExtracted;
            // this.$store.commit('SET_SIDEBAR_STATUS', this.sidebarExtracted);
            this.$nextTick(() => {
                setTimeout(() => {
                    Vue.$EventBus.$emit('resize');
                }, 80);
            });
        },
        onMousewheel(e) {
            if (this.sidebarExtracted || !this.canExtract) {
                return;
            }

            let elem = this.$refs.sidebarCon;
            let scrollTop = elem.scrollTop;
            let dir = e.deltaY ? (e.deltaY < 0 ? 'up' : 'down') : void 0;

            if (dir === 'up' && scrollTop <= 0) {
                return e.preventDefault();
            }

            if (dir === 'down' && (this.sidebarHeight + scrollTop) === elem.scrollHeight) {
                return e.preventDefault();
            }
        },
        onScroll() {
            this.expanderStyle = {
                transform: `translateY(${this.$refs.sidebarCon.scrollTop}px)`
            };
        }
    },
    mounted() {
        this.sidebarHeight = this.$refs.sidebarCon.offsetHeight;
    }
}
</script>

<style>
@import '../../css/base/variables.css';

.sidebar {
    overflow-x: hidden;
    overflow-y: auto;
}

.sidebar::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

.sidebar::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, .40);
    border-radius: 0;
    border-radius: 0;
}

.sidebar::-webkit-scrollbar-track {
    background: #2c3440;
}


.sidebar h2 {
    cursor: pointer;
    .arrow-toggle {
        float: right;
        line-height: 45px;
        margin-right: 15px;
    }
}

.menu-expand {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 9;
    background: var(--Deepbluegrey);

    height: 35px;
    line-height: 35px;
    padding-left: 20px;
    overflow: hidden;
    color: var(--Palebluegrey);

    & > svg {
        float: right;
        margin: 8px 10px 0 0;
        cursor: pointer;

        > path {
            fill: var(--Palebluegrey);
        }

        &:hover > path {
            fill: #fff;
        }
    }

    & > svg.extracted {
        -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
    }
}

.sidebar-extract {
    width: 60px;
    overflow: initial;
}
.sidebar-extract + .content {
    margin-left: 60px;
}
.sidebar-extract + .content + .footer {
    padding-left: 60px;
}

.sidebar-extract .menu-expand {
    padding: 0;
    text-align: center;

    & > span {
        display: none;
    }
    & > svg {
        float: none;
        display: inline-block;
        margin: 0;
        padding: 0;
        vertical-align: middle;
    }
}


.sidebar-extract section {
    position: relative;
    height: 45px;

    &:before {
        display: none;
    }

    > h2 {
        padding: 0;
        text-align: center;

        > .menu-icon {
            margin: 0;
        }
        > .menu-title {
            display: none;
        }

        > .arrow-toggle {
            display: none;
        }
    }

    &:hover > h2 {
        background: #475466;

        > .menu-icon {
            display: none;
        }
        > .menu-title {
            display: block;
            white-space: nowrap;
            font-size: 12px;
        }

        + .submenu {
            display: block;
            position: absolute;
            left: 100%;
            top: 0;
            z-index: 1;
            width: 120px;
            padding: 6px 15px;

            > li > a {
                padding: 0;
                &:before {
                    display: none;
                }
            }
        }
    }
    .submenu {
        display: none;
    }
}

.sidebar li a.disabled:hover {
    color: #b2b2b2;
}
.sidebar li a.disabled:hover:before {
    background-color: #475467;
}
.submenu .submenu-item {
  position: relative;
}
.submenu-item .new-func {
  background: url("https://p5.ssl.qhimg.com/t0132d38f57f054918f.png") no-repeat;
  display: inline-block;
  width: 31px;
  height: 14px;
  margin-left: 10px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// unit.vue?76e238de